import TransactionGroup from '../models/TransactionGroup'

export const mockTransactionGroups: Array<TransactionGroup> = [
  {
    id: 1,
    name: 'Λογαριασμοί, κάρτες (debit/prepaid), αξιόγραφα και συναφείς τραπεζικές εργασίες',
    sidebarText:
      'Λογαριασμοί, κάρτες<br>(debit/prepaid), αξιόγραφα<br>και συναφείς τραπεζικές<br>εργασίες',
    sidebarLongText:
      'Λογαριασμοί, κάρτες (debit/prepaid), αξιόγραφα και συναφείς τραπεζικές εργασίες',
  },
  {
    id: 2,
    name: 'Συνομολόγηση σύμβασης acquiring - Προμήθεια του αναγκαίου τερματικού εξοπλισμού',
    sidebarText:
      'Συνομολόγηση σύμβασης<br>acquiring - Προμήθεια του<br>αναγκαίου τερματικού εξοπλισμού',
    sidebarLongText:
      'Συνομολόγηση σύμβασης acquiring - Προμήθεια του αναγκαίου τερματικού εξοπλισμού',
  },
  {
    id: 3,
    name: 'Δάνεια/ Πιστώσεις',
    sidebarText: 'Δάνεια/ Πιστώσεις',
    sidebarLongText: 'Δάνεια/ Πιστώσεις',
  },
  {
    id: 4,
    name: 'Παροχή εμπράγματης ή χρηματοοικονομικής ασφάλειας επί κινητών και ακινήτων σε ασφάλεια απαιτήσεων της Τράπεζας κατά του ιδίου Ν.Π.',
    sidebarText:
      'Παροχή εμπράγματης<br>ή χρηματοοικονομικής<br>ασφάλειας επί κινητών<br>και ακινήτων σε ασφάλεια<br>απαιτήσεων της Τράπεζας<br>κατά του ιδίου Ν.Π.',
    sidebarLongText:
      'Παροχή εμπράγματης ή χρηματοοικονομικής ασφάλειας επί κινητών και ακινήτων σε ασφάλεια απαιτήσεων της Τράπεζας κατά του ιδίου Ν.Π.',
  },
  {
    id: 5,
    name: 'Πράξεις υπέρ τρίτου προσώπου (Φ.Π./Ν.Π.)',
    sidebarText: 'Πράξεις υπέρ τρίτου<br>προσώπου (Φ.Π./Ν.Π.)',
    sidebarLongText: 'Πράξεις υπέρ τρίτου προσώπου (Φ.Π./Ν.Π.)',
  },
  {
    id: 6,
    name: 'Επενδυτικές και παρεπόμενες υπηρεσίες',
    sidebarText: 'Επενδυτικές και<br>παρεπόμενες υπηρεσίες',
    sidebarLongText: 'Επενδυτικές και παρεπόμενες υπηρεσίες',
  },
  {
    id: 7,
    name: 'Συμβάσεις συναλλακτικής τραπεζικής',
    sidebarText: 'Συμβάσεις συναλλακτικής<br>τραπεζικής',
    sidebarLongText: 'Συμβάσεις συναλλακτικής τραπεζικής',
  },
  {
    id: 8,
    name: 'Εκπροσώπηση e-Banking',
    sidebarText: 'Εκπροσώπηση e-Banking',
    sidebarLongText: 'Εκπροσώπηση e-Banking',
  },
  {
    id: 9,
    name: 'Ειδική εκπροσώπηση για Online αποστολή νομιμοποιητικών εγγράφων μέσω e-Banking',
    sidebarText:
      'Εκπροσώπηση για <br>Online αποστολή <br>νομιμοποιητικών <br>εγγράφων μέσω e-Banking',
    sidebarLongText:
      'Ειδική εκπροσώπηση για Online αποστολή νομιμοποιητικών εγγράφων μέσω e-Banking',
  },
  {
    id: 10,
    name: 'Ειδική εκπροσώπηση V-Banking',
    sidebarText: 'Εκπροσώπηση V-Banking',
    sidebarLongText: 'Ειδική εκπροσώπηση V-Banking',
  },
]
